<script>
export default {
  name: "MainSearchNoResults",
  props: {
    searchString: {
      type: String
    }
  }
}
</script>

<template>
<div class="no-results-wrap">
  <div class="no-results-img"></div>
  <div class="no-results-text">
    <span class="no-results-text__item">{{$t('mainSearch.noSearchFor')}} "{{searchString}}"!</span>
    <span class="no-results-text__item">
      {{$t('mainSearch.maybeYourSearchWas')}}
    </span>
  </div>
</div>
</template>

<style lang="scss" scoped>
.no-results-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background: #fff;
  .no-results-img {
    width: 100px;
    min-width: 100px;
    height: 100px;
    margin-right: 30px;
    background: url("~@/assets/img/no-results/no-results-1.svg") no-repeat;
    background-size: 100%;
  }

  .no-results-text {
    &__item {
      display: inline-block;
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      color: #4f4f4f;
    }
  }
}

</style>